import { classNames } from "../../../utils/classNames";
import React, { FC } from "react";
import { Col, Grid, Row } from "react-flexbox-grid";
import { RouteComponentProps } from "react-router-dom";

import styleLegacy from "./styleLegacy.scss";

export interface PricingStateProps {}

export interface PricingDispatchProps {}

export interface PricingOwnProps extends RouteComponentProps<any> {}

export type PricingProps = PricingStateProps & PricingDispatchProps & PricingOwnProps;

const Pricing: FC<PricingProps> = () => {
    return (
        <Grid>
            <Row around="xs">
                <Col xs>
                    <div className={styleLegacy.plancontainer}>
                        <div className={styleLegacy.planheader}>
                            <h2>VOICE RADIO</h2>
                            <p>$69.99 setup fee</p>
                            <p>$69.99/month</p>
                        </div>
                        <div className={styleLegacy.plandetails}>
                            <ul>
                                <li>Live stream</li>
                                <li>Custom welcome message</li>
                                <li>
                                    $49.99 setup fee + $49.99/month <span>for each additional app</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xs>
                    <div className={styleLegacy.plancontainer}>
                        <div className={classNames(styleLegacy.planheader, styleLegacy.pro)}>
                            <h2>VOICE RADIO PRO</h2>
                            <p>$99.99 setup fee</p>
                            <p>$99.99/month</p>
                        </div>
                        <div className={styleLegacy.plandetails}>
                            <ul>
                                <li>Everything from Voice Radio</li>
                                <li>Branded Amazon Alexa account</li>
                                <li>Real-time analytics access</li>
                                <li>
                                    $69.99 setup fee + $69.99/month <span>for each additional app</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xs>
                    <div className={styleLegacy.plancontainer}>
                        <div className={styleLegacy.planheader}>
                            <h2>VOICE RADIO PRO+</h2>
                            <p>Custom Pricing for 10+ Stations</p>
                        </div>
                        <div className={styleLegacy.plandetails}>
                            <ul>
                                <li>Everything from Voice Radio & Voice Radio Pro</li>
                                <li>Other custom features</li>
                            </ul>
                            <p>XAPP is the only company delivering Alexa skills for radio at scale today </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Grid>
    );
};

export default Pricing;
